import React from 'react';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { connect } from 'react-redux';
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Switch,
  Button,
  Modal,
  Badge,
  message,
  Tooltip,
  Select,
  Checkbox,
} from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import FileLink from "../../components/FileLink/FileLink";
import classes from './DocumentsEditor.css';

import isAuthenticated from '../../utils/isAuthenticated';
import {
  getDocumentsSearchRequest,
  deleteDocumentRequest,
  activateDocumentRequest,
  unapproveDocumentRequest,
  approveDocumentRequest,
  getSitesRequest
} from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import {
  getDocumentCreatePermission,
  getDocumentApprovePermission,
  getDocumentUnapprovePermission,
  getDocumentDeletePermission,
  getDocumentUpdatePermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentGeneralPrivateReadPermission, getDocumentPerSiteReadPermission, getDocumentValidationReadPermission
} from "../../reducers/user/selectors";
import DocumentForm, { documentTypes }  from "../../components/DocumentForm/DocumentForm";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const mapped_categories = {
  public: 'Public',
  general: 'Central Shared',
  general_private: 'Central Private',
  per_site: 'Site Specific',
  training: 'Training',
  validation: 'Validation'
}

class DocumentsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      nameSearch: null,
      sortedInfo: { columnKey: 'order_index', order: 'ascend'},
      order: 'asc',
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      documentEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      approvedSelected: null,
    };
  }

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  }

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, filterBy: null, filterValue: null, eventsSelected: {} }, this.getDocuments);
  };

  getDocuments = async (page = this.state.currentPage, per_page = this.state.pageSize) => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getDocumentsSearchRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        order_column: get(this.state, 'sortedInfo.columnKey'),
        page,
        per_page,
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve: this.state.approvedSelected !== null ? this.state.approvedSelected : null,
      });

      if (Array.isArray(data.data)) {
        this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
      } else {
        this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
      }
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ documents: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      isLoading: true,
      pageSize: pagination.pageSize,
      sortedInfo: sorter,
      order: get(sorter, 'order') === 'ascend' ? 'asc' : get(sorter, 'order') === 'descend' ? 'desc' : 'asc',
    }, () => this.getDocuments(pagination.current, pagination.pageSize));
  };

  onDocumentEdit = document => () => {
    this.setState({ documentEdit: document });
  };

  onDocumentEditHide = () => {
    this.setState({ documentEdit: null });
  };

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null }, this.getDocuments);
  };

  addDocument = () => {
    this.setState({ documentEdit: {} });
  };

  onSwitchDocumentActivation = (id, state) => async () => {
    try {
      if (state === 'active') {
        await deleteDocumentRequest(id);
      } else {
        await activateDocumentRequest(id);
      }

      message.success('Saved');

      this.getDocuments();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error('Error');
      console.log(e);
    }
  };

  onSwitchDocumentApprove = (id, approved) => async () => {
    try {
      if (approved) {
        await unapproveDocumentRequest(id);
      } else {
        await approveDocumentRequest(id);
      }

      message.success('Saved');

      this.getDocuments();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error('Error');
      console.log(e);
    }
  };

  handleFilterChange = index => value => {
    this.setState(state => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = index => value => { this.setState(state => {
    const filtersValue = cloneDeep(state.filtersValue);
    filtersValue[index] = value;
    return { filtersValue };
  }, this.getDocuments) };

  clearFilter = index => () => { this.setState(state => {
    const filtersBy = cloneDeep(state.filtersBy);
    const filtersValue = cloneDeep(state.filtersValue);

    filtersBy.splice(index, 1);
    filtersValue.splice(index, 1);

    return { filtersBy, filtersValue };

  }, this.getDocuments)};

  clearFilters = () => { this.setState({ nameSearch: null }, this.getDocuments); };

  onSelectApprovedStatus = approvedStatusType => () => {
    let status;
    const { approvedSelected } = this.state;

    if (approvedSelected === null && approvedStatusType === 'approved') { status = false; }
    if (approvedSelected === true && approvedStatusType === 'approved') { status = false; }
    if (approvedSelected === false && approvedStatusType === 'approved') { status = null; }

    if (approvedSelected === null && approvedStatusType === 'unapproved') { status = true; }
    if (approvedSelected === false && approvedStatusType === 'unapproved') { status = true; }
    if (approvedSelected === true && approvedStatusType === 'unapproved') { status = null; }

    this.setState(_ => ({ approvedSelected: status }), this.getDocuments);
  };

  renderFilterItem = (index = this.state.filtersBy.length) => {
    const {filtersBy, filtersValue, sites } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>Filter by</b>
            <Select onChange={this.handleFilterChange(index)} value={filtersBy[index]} style={{width: '100%'}} placeholder='Select'>
              <Option value='category' disabled={filtersBy.includes('category')}>Category</Option>
              <Option value='type' disabled={filtersBy.includes('type')}>Document type</Option>
              <Option value='site' disabled={filtersBy.includes('site')}>Site</Option>
              <Option value='state' disabled={filtersBy.includes('state')}>State</Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === 'category' && (<label className={classes.searchWrapperFilterItem}>
          <b className={classes.searchWrapperLabel}>Category</b>
          <Select mode="multiple" onChange={this.handleFilterValueChange(index)} value={filtersValue[index]} style={{width: '100%'}}
                  placeholder='Select'>
            <Option value='public' disabled={!this.props.documentPublicReadPermission}>Public</Option>
            <Option value='general' disabled={!this.props.documentGeneralReadPermission}>Central Shared</Option>
            <Option value='general_private' disabled={!this.props.documentGeneralPrivateReadPermission}>Central
              Private</Option>
            <Option value='per_site' disabled={!this.props.documentPerSiteReadPermission}>Site Specific</Option>
            <Option value='training' disabled={!this.props.documentTrainingReadPermission}>Training</Option>
            <Option value='validation' disabled={!this.props.documentValidationReadPermission}>Validation</Option>
          </Select>
        </label>)}

        {filtersBy[index] === 'type' && (<label className={classes.searchWrapperFilterItem}>
          <b className={classes.searchWrapperLabel}>Document type</b>
          <Select mode="multiple" onChange={this.handleFilterValueChange(index)} value={filtersValue[index]} style={{width: '100%'}} placeholder='Select'>
            {Object.keys(documentTypes).map((key) => (
              <Option value={key} key={key}>{documentTypes[key]}</Option>
            ))}
          </Select>
        </label>)}

        {filtersBy[index] === 'site' && (<label className={classes.searchWrapperFilterItem}>
          <b className={classes.searchWrapperLabel}>Site</b>
          <Select onChange={this.handleFilterValueChange(index)} value={filtersValue[index]} style={{width: '100%'}}
                  placeholder='Select'>
            {sites.map(site => (
              <Option key={site.id} value={site.id}>{site.code} - {site.name}</Option>
            ))}
          </Select>
        </label>)}

        {filtersBy[index] === 'state' && (<label className={classes.searchWrapperFilterItem}>
          <b className={classes.searchWrapperLabel}>Active state</b>
          <Select onChange={this.handleFilterValueChange(index)} value={filtersValue[index]} style={{width: '100%'}}
                  placeholder='Select'>
            <Option value='active'>Active</Option>
            <Option value='inactive'>Inactive</Option>
          </Select>
        </label>)}

        {filtersBy[index] === 'approved' && (<label className={classes.searchWrapperFilterItem}>
          <b className={classes.searchWrapperLabel}>Is approved</b>
          <Select onChange={this.handleFilterValueChange(index)} value={filtersValue[index]} style={{width: '100%'}}
                  placeholder='Select'>
            <Option value='true'>Yes</Option>
            <Option value='false'>No</Option>
          </Select>
        </label>)}

        {filtersValue[index] && <span className={classes.clearButton} onClick={this.clearFilter(index)}>Remove</span>}
      </div>
    );
  };

  render() {
    const { errorMessage, isLoading, responseMessage, nameSearch, documents, currentPage, total, pageSize, documentEdit, sortedInfo, filtersBy, filtersValue, approvedSelected } = this.state;
    const { documentCreatePermission } = this.props;

    const columns = [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: "Index",
        render: val => (<span>{val}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: "Document Name",
        render: (val, record) => (<div className={classes.nameDocumentWrapper}>
          <div style={{ width: '86px' }}>
            <Badge count={record.state} style={{ backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} />
            <br/>
            {record.state === 'active' && <Badge count={record.approved ? 'approved' : 'unapproved'} style={{ backgroundColor: record.approved ? '#52c41a' : '#777' }} />}

          </div>
          {val}
        </div>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'name' && sortedInfo.order,
      },
      {
        dataIndex: "type",
        key: "type",
        title: "Document Type",
        render: val => (<span>{documentTypes[val]}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'type' && sortedInfo.order,
      },
      {
        dataIndex: "site",
        key: "site",
        title: "Site",
        render: (val, document) => {
          return (
            <div>
              {get(document, 'category') === 'public' && get(val, 'name', 'General')}
              {get(document, 'category') !== 'public' && get(val, 'name')}
            </div>

        )},
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'site' && sortedInfo.order,
      },
      {
        dataIndex: "category",
        key: "category",
        title: "Category",
        render: category => category ? mapped_categories[category] || '' : '',
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'category' && sortedInfo.order,
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: "Start date",
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'start_year' && sortedInfo.order,
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: "Expiry date",
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'expiry_year' && sortedInfo.order,
      },
      {
        dataIndex: "user",
        key: "user",
        title: "Uploaded by",
        render: user => get(user, 'username'),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'user' && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "id",
        title: "Actions",
        render: (val, document) => (<div className={classes.actions}>
          <FileLink url={document.url} />
          &nbsp; &nbsp;
          <Tooltip placement="topLeft" title="Edit Document">
            <Icon type="edit" theme="filled" className={classes.iconEdit} onClick={this.onDocumentEdit(document)} />
          </Tooltip>
          &nbsp; &nbsp;
          <div style={{ width: '90px', display: 'flex' }}>
            {((this.props.documentUpdatePermission && document.state === 'inactive') || (this.props.documentDeletePermission && document.state === 'active')) && <div>
              <b className={classes.switchLabel}>State</b><br/>
              <Tooltip placement="topLeft" title="Activate / Deactivate Document">
                <Switch className={classes.reactivateBtn} checked={document.state === 'active'} onChange={this.onSwitchDocumentActivation(val, document.state)} />
              </Tooltip>
            </div>}
            &nbsp; &nbsp;
            {document.state === 'active' && ((this.props.documentApprovePermission && !document.approved) || (this.props.documentUnapprovePermission && document.approved)) && <div>
              <b className={classes.switchLabel}>Approve</b><br/>
              <Tooltip placement="topLeft" title="Approve / Unapprove Document">
                <Switch className={classes.reactivateBtn} checked={document.approved} onChange={this.onSwitchDocumentApprove(val, document.approved)} />
              </Tooltip>
            </div>}
          </div>
        </div>)
      },
    ];

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>
                <AdminHeader />
                <Content className={classes.content}>
                  <h3 className='headline-default'>Trial Documents</h3>

                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>SEARCH</b>
                      <Search
                        placeholder="By name"
                        enterButton="Search"
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={this.onNameChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>

                    <span className={classes.clearButton} onClick={this.clearFilters}>Clear</span>
                  </div>


                  <h4 className='headline-default'>Filter</h4>

                  <div className={classes.wrapperFilters}>
                    <div className={classes.searchWrapperFilterItemApprove}>
                      <Checkbox onChange={this.onSelectApprovedStatus('approved')}
                                checked={approvedSelected === null || approvedSelected === true}>Approved</Checkbox>
                      <Checkbox onChange={this.onSelectApprovedStatus('unapproved')}
                                checked={!approvedSelected}>Unapproved</Checkbox>
                    </div>

                    {filtersBy.map((_, index) => this.renderFilterItem(index))}

                    {filtersBy.length === filtersValue.length && filtersBy.length !== 4 && this.renderFilterItem()}
                  </div>

                  {errorMessage && (<Alert type='error' message={errorMessage} className={classes.alert} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} className={classes.alert} />)}

                  {documentCreatePermission && <div><Button type='primary' onClick={this.addDocument}>Add new document</Button><br/><br/></div>}

                  <Table
                    columns={columns}
                    dataSource={documents}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100']
                    }}
                  />

                  {/*{isLoading && <Icon type="loading" />}*/}

                  <Modal
                    visible={!!documentEdit}
                    onCancel={this.onDocumentEditHide}
                    footer={null}
                  >
                    {documentEdit && <DocumentForm {...documentEdit} isNew={documentEdit && !documentEdit.id} onSubmit={this.onDocumentEditSubmit} onCancel={this.onDocumentEditHide} />}
                  </Modal>

                </Content>
                <Footer noAdminLink />
            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  documentCreatePermission: getDocumentCreatePermission(state),
  documentApprovePermission: getDocumentApprovePermission(state),
  documentUnapprovePermission: getDocumentUnapprovePermission(state),
  documentDeletePermission: getDocumentDeletePermission(state),
  documentUpdatePermission: getDocumentUpdatePermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(state),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(DocumentsEditor));



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/DocumentsEditor.js